import clsx from 'clsx';
import styles from './ProgressBar.module.css';

export interface ProgressBarProps {
  /** Share done in [0, 1]; null when the amount of work is unknown. */
  readonly value: number | null;
  /** Accessible name, e.g. "Uploading". */
  readonly label: string;
  /** Spoken value, e.g. "1.2 of 4.3 GB". */
  readonly valueText?: string | undefined;
  readonly tone?: 'accent' | 'neutral' | 'success' | undefined;
  readonly className?: string | undefined;
}

export const ProgressBar = ({ value, label, valueText, tone = 'accent', className }: ProgressBarProps) => {
  const clamped = value === null ? null : Math.min(1, Math.max(0, value));
  return (
    <div
      className={clsx(styles.track, className)}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={clamped === null ? undefined : Math.round(clamped * 100)}
      aria-valuetext={valueText}
    >
      <span
        className={clsx(styles.fill, styles[tone], clamped === null && styles.indeterminate)}
        style={clamped === null ? undefined : { transform: `scaleX(${clamped})` }}
      />
    </div>
  );
};
